(function(){
  function isInteractive(target){
    return !!target.closest('[data-interactive], a, button, select, input, textarea, summary');
  }

  document.addEventListener('click', function(e){
    var card = e.target.closest('.js-card-link[data-card-url]');
    if (!card) return;
    if (isInteractive(e.target)) return;
    var url = card.getAttribute('data-card-url');
    if (url) { window.location.href = url; }
  }, { passive: true });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest('.js-card-link[data-card-url]');
    if (!card) return;
    if (isInteractive(e.target)) return;
    var url = card.getAttribute('data-card-url');
    if (url) {
      e.preventDefault();
      window.location.href = url;
    }
  });
})();
